<template>
  <div class="hero-section">
    <h1>Ne zamudite priložnosti z <span class="highlight">Avtovizijo</span></h1>
    <p>Avtomatizirajte objavljanje vozil na spletu s prilagojenim avtomatiziranim sistemom. Pospešite svoje poslovanje, prihranite dragocen čas in bodite vedno korak pred konkurenco.</p>
    <div class="hero-buttons">
      <router-link to="/login" class="btn btn-primary">Prijava</router-link>
      <router-link to="/register" class="btn btn-secondary">Registracija</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      content: "",
    };
  },
  computed: {
    message() {
      return this.$route.query.message;
    }
  },
};
</script>
